<template>
  <div id="task-steps" ref="taskInfo">
    <el-row class="steps-list">
      <transition name="fade" mode="out-in">
        <ul class="list-step-squares">
          <li
            v-for="__step in statusSteps"
            :key="__step.status"
            :style="{ background: __step.backgroundColor }"
            class="list-step-square">
            <el-row :gutter="24" class="mt-10">
              <el-col :span="8">
                <img
                  v-if="__step.image"
                  class="list-step-image"
                  :style="__step.imageStyle"
                  :src="__step.image"
                  alt="">
              </el-col>
              <el-col :span="16">
                <div class="list-step-square-title mb-10 display-block">
                  <strong :style="{ color: __step.titleColor }" class="mt-5 display-block">
                    {{ __step.title }}
                  </strong>
                  <strong :style="{ color: __step.descriptionColor }" class="mt-10 display-block">
                    {{ __step.description }}
                  </strong>
                </div>
                <div class="list-step-square-title mt-10" :style="{ color: __step.descriptionColor }">
                  <span v-if="isStepTime(__step.time)">
                    {{ __step.time }}
                  </span>
                  <span v-else>
                    <el-tooltip effect="dark" :content="getDate(__step.time)" placement="bottom-start">
                      <i class="el-icon-time pointer" />
                    </el-tooltip>
                    {{ $t('general.lastUpdate') }}  {{ __step.time | dateHourFormat }}
                  </span>
                </div>
              </el-col>
            </el-row>
          </li>
        </ul>
      </transition>
    </el-row>
  </div>
</template>
<script>
// Utils
import { object, inProgres } from '@/utils/status'
import { customerName } from '@/utils/functions'

const STEP_TYPES = {
  ACTIVE: 'active',
  PULSING: 'pulsing',
  DISABLED: 'disabled'
}

const STEP_COLORS = {
  PENDING: {
    backgroundColor: '#ffc633',
    titleColor: '#3E4250',
    descriptionColor: '#CD810F'
  },
  TRANSIT: {
    backgroundColor: '#9ca5c6',
    titleColor: '#ffffff',
    descriptionColor: '#3E4250'
  },
  ONSITE: {
    backgroundColor: '#56f2a7',
    titleColor: '#ffffff',
    descriptionColor: '#3E4250'
  },
  COMPLETED: {
    backgroundColor: '#5161fb',
    titleColor: '#ffffff',
    descriptionColor: '#ffffff'
  },
  CANCELED: {
    backgroundColor: '#FD868C',
    titleColor: '#3E4250',
    descriptionColor: '#FFCFCF'
  }
}

export default {
  name: 'TaskCardSteps',
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    steps: [...inProgres],
    object
  }),
  computed: {
    driverName: function() {
      let _driver = this.$t('general.yourDriver')
      if (this.value.thirdPartyData && this.value.thirdPartyData.driver && this.value.thirdPartyData.driver.name) {
        _driver = this.value.thirdPartyData.driver.name
      }
      return _driver
    },
    _step: {
      get() {
        return this.steps.indexOf(this.value.orderStep)
      }
    },
    stepsHistory: function() {
      const steps = {}
      for (const _element of this.value.movements) {
        steps[_element.status] = _element.createdAt
      }
      return steps
    },
    inTransitStatus: function() {
      return object.TRANSIT === this.value.orderStep
    },
    statusSteps: function() {
      const data = []
      const status = JSON.parse(JSON.stringify(this.steps))
      let _statusMov = ''
      status.forEach(val => {
        if (Array.isArray(this.value.movements)) {
          this.value.movements.forEach(mov => {
            _statusMov = val
            if (val === mov.status) {
              _statusMov = mov.status
            }
          })
          const STATUS_TO_IGNORE_PROGRESS = ['CANCEL_REQUEST', 'DRIVER_IN_BRANCH', 'SUPPLIED', 'ACCEPTED', 'BRANCH_DISPATCH']
          if (!STATUS_TO_IGNORE_PROGRESS.includes(val)) {
            const statusName = typeof _statusMov === 'string' ? _statusMov.toUpperCase() : ''
            const stepStatus = this.getStepStatus((data.length + 1), this.value.customIndicators.statusLevel)
            const isGrayStep = stepStatus === STEP_TYPES.DISABLED
            const backgroundColor = !isGrayStep ? STEP_COLORS[`${statusName}`].backgroundColor : '#d0d0d0'
            const titleColor = !isGrayStep ? STEP_COLORS[`${statusName}`].titleColor : '#ffffff'
            const descriptionColor = !isGrayStep ? STEP_COLORS[`${statusName}`].descriptionColor : '#ffffff'
            const imageStyle = isGrayStep ? 'filter: grayscale(100%)' : ''
            const _data = {
              stepStatus,
              backgroundColor,
              titleColor,
              descriptionColor,
              isGrayStep,
              imageStyle,
              image: `/img/status/status_${statusName.toLowerCase()}.png`,
              status: _statusMov,
              title: this.stepTitle(val),
              description: this.stepDescription(val),
              time: this.showStatusDate(val)
            }
            data.push(_data)
          }
        }
      })
      return data
    }
  },
  watch: {
    'value.orderStep': function(val) {
      if ([object.CANCELED].includes(val)) {
        this.$emit('close')
      }
    }
  },
  mounted() {
    // Add movements history to dictonary object
    if (this._step !== object.CANCELED && !inProgres.includes(object.COMPLETED)) {
      if (this.steps.includes(object.CANCELED)) {
        this.steps.pop()
      }
      this.steps.push(object.COMPLETED)
    }
  },
  methods: {
    isStepTime: function(stepTime) {
      return stepTime === '--:--'
    },
    getStepStatus: function(stepLevel, statusLevel) {
      let status = STEP_TYPES.ACTIVE
      if (stepLevel < statusLevel) {
        status = STEP_TYPES.ACTIVE
      } else if (stepLevel === statusLevel) {
        status = STEP_TYPES.PULSING
      } else if (stepLevel > statusLevel) {
        status = STEP_TYPES.DISABLED
      }
      return status
    },
    getDate: function(statusDate) {
      let format = 'HH:mm'
      const date = this.$moment(statusDate).hours(0).minutes(0).seconds(0).milliseconds(0)
      const currentDate = this.$moment().hours(0).minutes(0).seconds(0).milliseconds(0)
      if (Math.abs(date.diff(currentDate, 'days')) >= 1) {
        format = 'dddd, MMMM Do YYYY, HH:mm'
      }
      return this.$moment(statusDate).format(format)
    },
    isStatus: function(status, currentStatus) {
      return currentStatus === status
    },
    showStatusDate: function(status) {
      let textStatus = '--:--'
      if (this.stepsHistory[status]) {
        textStatus = this.stepsHistory[status]
      }
      return textStatus
    },
    stepTitle: function(step) {
      let _step = this.$t(`steps.${step}.title`, { name: customerName(this.value) })
      const STATUS_FOR_SIMPLE_DISPLAY = [object.PENDING, object.ACCEPTED, object.SUPPLIED]
      if (STATUS_FOR_SIMPLE_DISPLAY.includes(step)) {
        _step = this.$t(`steps.${step}.title`, { name: customerName(this.value) })
      } else if (step === object.TRANSIT) {
        _step = this.$t(`steps.${step}.title`, { name: this.driverName })
      } else if (step === object.ONSITE) {
        _step = this.$t(`steps.${step}.title`)
      }
      return _step
    },
    stepDescription: function(step) {
      let _step = this.$t(`steps.${step}.description`, { name: customerName(this.value) })
      const STATUS_FOR_SIMPLE_DISPLAY = [object.PENDING, object.ACCEPTED, object.SUPPLIED]
      if (STATUS_FOR_SIMPLE_DISPLAY.includes(step)) {
        _step = this.$t(`steps.${step}.description`, { name: customerName(this.value) })
      } else if (step === object.TRANSIT) {
        _step = this.$t(`steps.${step}.description`, { name: this.driverName })
      } else if (step === object.ONSITE) {
        _step = this.$t(`steps.${step}.description`, { name: this.driverName })
      }
      return _step
    }
  }
}
</script>
